// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vimeo_wrapper__2Ez5u","iframe":"vimeo_iframe__205DA"};